<template>
    <div class="ucenter">
        <header>
            <img :src='userInfo.avatar' alt="" class="avatar">
            <h3 class="user_name">{{userInfo.nickname}}</h3>
            <span class="user_brief" v-if="userInfo.brief"> {{userInfo.brief}} </span>
            <span class="user_brief" v-if="!userInfo.brief"> 这家伙很懒，什么也没有留下 </span>
            <a href="/login/loging_out" class="login_out">退出</a>
        </header>
        <div class="bd">
            <!--20200515 <div class="cellbox ">
                <div class="cell-wrapper goldbox">
                    账户余额：<span class="gold">{{userInfo.total_gold}}金币</span>
                    <a href="/xiaomiquan/recharge.html" class="account_recharge">充值</a>
                </div>                
            </div> -->
            <div class="cellbox-warp">
                <a :href='userInfo.l_id==0 ? "/ucenter/user_home/m_u_id/"+userInfo.id+".html":"/lives/center/id/"+userInfo.l_id+".html"' class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-home"></i> 
                        <div class="cell-title">                          
                            <span>我的主页</span>
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a>
                <a href="/ucenter/user_info_modify" class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-userinfo"></i> 
                        <div class="cell-title">                          
                            <span>个人资料</span>
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a>
                <!--20200515 <a href="/StockGuess/market" class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-guess"></i> 
                        <div class="cell-title no-border">                          
                            <span>趣味竞猜</span>
                            <span class="tips">参与竞猜赢金币！</span>
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a> -->
            </div>
            <div class="cellbox-warp">
                <!--20200515 <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-appdl"></i> 
                        <div class="cell-title">                          
                            <span>爱股票app下载</span>
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a> -->
                <a href="/index/about.html" class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-aboutus"></i> 
                        <div class="cell-title">                          
                            <span>关于我们</span>
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a>
                <a href="/index/statement.html" class="cellbox">                
                    <div class="cell-wrapper">
                        <i class="indexicon icon-statement"></i> 
                        <div class="cell-title no-border">                          
                            <span>免责声明</span>                          
                            <i class="cell-allow-right"></i>
                        </div>                       
                    </div>                
                </a>
            </div>
        </div>
    </div>
</template>

<script>

// import UserProfilesApi from '@/api/userProfiles/';
import ucenterApi from '@/api/mine/ucenter';
import { mapActions } from 'vuex'

export default {
    name: 'ucenter',
    components: {

    },
    data() {
        return {
           userInfo: {}, 
           user_id: parseInt(this.$route.params.id)
        };
    },
    created() {
        this.getUser()
    },

    methods: {        
        //获取个人信息
        async getUser() {
            let data = await await ucenterApi.getUserInfo(); 
            this.userInfo = data;  
        }

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" >
body{
    background-color: #F0F0F0;
}

.ucenter{padding-bottom: 63px;}
.cellbox-warp{margin-top: 10px}
.indexicon{
    display: inline-block;
    width: 19px;
    height: 19px;    
    vertical-align: middle;
    margin: 18px 10px 0 0 ;
}
.goldbox{
    line-height: 54px;
    .gold{
        color: #FE484A;
        padding-left:10px
    }
}
.icon-home{
    background:url(../../assets/images/icon-userhome.png) no-repeat;
    background-size:cover;
}
.icon-userinfo{
    background:url(../../assets/images/icon-userinfo.png) no-repeat;
    background-size:cover;
}
.icon-guess{
    background:url(../../assets/images/icon-guess@2x.png) no-repeat;
    background-size:cover;
}
.icon-appdl{
    background:url(https://cdn.aigupiao.com/static/wrap/img/center_guess_ico4.png) no-repeat;
    background-size:cover;
}
.icon-aboutus{
   background:url(https://cdn.aigupiao.com/static/wrap/img/center_guess_ico5.png) no-repeat;
   background-size:cover; 
}
.icon-statement{
    background:url(../../assets/images/icon-disclaimer@2x.png) no-repeat;
    background-size:cover; 
}
.account_recharge{
    width:56px;
    height:30px;
    text-align: center;
    line-height: 30px;
    background:rgba(254,72,74,1);
    border-radius:4px;
    color: #fff;
    position:absolute;
    top: 13px;
    right: 20px;
    font-size: 13px;
}
.cellbox{
    background-color: #fff;
    box-sizing: border-box;
    color: inherit;
    min-height: 54px;
   
    display: block;
    overflow: hidden;
    position: relative;
    text-decoration: none;
    .cell-wrapper {             
        box-sizing: border-box;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        font-size: 16px; 
        min-height: inherit;
        overflow: hidden;
        padding: 0 0 0 14px;
        width: 100%;
    }
    .cell-title {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        height: 54px;
        line-height: 54px;
        border-bottom:1px solid #EBEBEB;
    }
    .cell-allow-right{
        top: 20px;
        right: 20px;
        position: absolute;
        display: inline-block;
        background: url(../../assets/images/icon-right-gray@2x.png) no-repeat;
        background-size: 100% 100%;
        width: 9px;
        height: 14px;
    }
    .tips{
        top: 0px;
        right: 30px;
        position: absolute;
        color: #939393;
        font-size: 15px
    }
    .no-border{
        border:none;
    }   
}

header{
    margin-top: 48px;
    width: 100%;
    height: 196px;
    background: url(../../assets/images/ucenter-bg.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
    position: relative;
    color: #fff;

    .avatar{
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border:4px solid rgba(255, 255, 255, 0.5);
        margin-top: 15px
    }
    .user_name{font-size: 17px; margin: 20px 0 10px 0;}
    .user_brief{font-size: 13px;}
    .login_out{
        position: absolute; 
        top:15px;
        right: 15px;
        width:49px;
        height:25px;
        line-height: 25px;
        display: inline-block;
        background:rgba(255,255,255,0.31);
        border-radius:3px;
        border:1px solid rgba(255,255,255,1);
        font-size: 13px;
        color: #fff
    }
}

</style>